export default __webpack_public_path__ + "media/images/logo/logo-1tvch-en-8a4e5ac9216fab46604631c801717cf6.png";